import "./ScaffoldingInFleet.module.css";
import Header from "@/reusable_sections/Header";
import Fleet from "./sections/Fleet";
import FleetIntro from "./sections/FleetIntro";
import FleetServices from "./sections/FleetServices";
import AccessSafety from "./sections/AccessSafety";
import FleetFaq from "./sections/FleetFaq";
import FinalQuote from "./sections/FinalQuote";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInFleetPage() {
  return <div>
      <Header />
      <Fleet />
      <FleetIntro />
      <FleetServices />
      <AccessSafety />
      <FleetFaq />
      <FinalQuote />
      <Footer />
    </div>;
}